import { LitElement, css, html, nothing } from "lit";
import { neutral } from "../../../../../../../legl-ui/lds-colours";
import "../../../../../../../legl-ui/lds-input";

export class LeglLawyersTableSearch extends LitElement {
  static get properties() {
    return {
      searchPlaceholder: {
        attribute: "search-placeholder",
        type: String,
      },
      onSearch: { attribute: false },
      value: { attribute: false },
    };
  }

  updated(changedProperties) {
    if (
      changedProperties.has("value") &&
      changedProperties.get("value") !== undefined
    ) {
      this.onSearch(this.value);
    }
  }

  render() {
    return html`
            <div class="wrapper">
                <lds-input
                    u-sr-only
                    data-cy-admin-table-search
                    prefix-icon="lds-icon-Search"
                    placeholder="${this.searchPlaceholder}"
                    .modelValue="${this.value}"
                    @model-value-changed="${(e) => {
                      this.value = e.target.modelValue;
                    }}"
                ></lds-input>
            </div>
        `;
  }
}

if (!customElements.get("legl-lawyers-table-search")) {
  customElements.define("legl-lawyers-table-search", LeglLawyersTableSearch);
}
